import {
  Calendar,
  CalendarFilter,
  Identifiable,
  Planzone,
  event as eventMock,
  milestone as milestoneMock,
  unavailability as unavailabilityMock,
  UnavailabilityReason,
  Constraint,
} from "@planzone/dto";
import { HttpClient, HttpMethods } from "@planzone/services";

function getConstraints(httpClient: HttpClient) {
  return () =>
    httpClient
      .sendHttpRequest<{
        _embedded: {
          constraints: (Identifiable<Constraint> & {
            targetStartDate: string;
            targetEndDate: string;
            targetIsDone: boolean;
            originStartDate: string;
            originEndDate: string;
            originIsDone: boolean;
          })[];
        };
      }>({
        endpoint: "/constraint",
        method: HttpMethods.GET,
      })
      .then(({ _embedded }) =>
        _embedded && _embedded.constraints ? _embedded.constraints : [],
      );
}

export { getConstraints };
